import React from 'react'

import './WorkloadChart.css'

import IndicatorsPool from '../../../../js/IndicatorsPool';
import { VictoryChart, VictoryGroup, VictoryStack, VictoryBar, VictoryTooltip, VictoryArea, VictoryLegend, VictoryAxis, VictoryLabel } from 'victory';
import MyTooltip from '../MyTooltip/MyTooltip';
import { store } from '../../../../stores/store';


const WorkloadChart = () => {

  let months = []
  for(let m = 1; m <=12; m++) {
    months.push(store.t("month" + m))
  }

  let inds = months.map( (m, i) => {

    // return ["indF141", "indF" + (142 + i), "indF" + (156 + i)]
    return ["indF" + (195 + i), "indF" + (142 + i), "indF" + (156 + i)]

  })

  let datas = []

  for(let i =0; i<3;i++) {
    datas.push(months.map((m, j) => {
      let indId = inds[j][i]
      let val = parseFloat(IndicatorsPool.getIndicatorValue(indId, true))
      let ind = IndicatorsPool.getIndicator(indId)
      return {x: m, y: val, label: `${ind.title}${store.language === "fr" ? "&nbsp;" : ""}:&nbsp;${val}${ind.unit}` }
    }))
  }



  let val1 = IndicatorsPool.getIndicatorValue("indF154")

  const area1Data = months.map( m => ({x: m, y: val1}) )

  let val2 = IndicatorsPool.getIndicatorValue("indF155") + val1
  const area2Data = months.map( m => ({x: m, y: val2, y0: val1}) )


  let legend1 = IndicatorsPool.getIndicator("indF154")
  let legend2 = IndicatorsPool.getIndicator("indF155")


  return (
    <div className="WorkloadChart">
      <VictoryChart
      padding={{left: 80, top: 40, bottom: 30}}
      animate={{onLoad: { delay: 0, duration: 1 }, duration: 500}}
      domainPadding={{ x: 100, y: 0 }}
      width={700}
      height={400} >


        <VictoryLegend x={125} y={0}
          orientation="horizontal"
          style={{ border: { stroke: "black" }, title: {fontSize: 15 } }}
          data={[
            { name: legend1.title, symbol: { fill: "#70AD47" , type: "square" } },
            { name: legend2.title, symbol: { fill: "#FFC000" , type: "square" } }
          ]}
        />


        <VictoryGroup color="#70AD47">
          <VictoryArea  data={area1Data} labelComponent={<MyTooltip />} />
        </VictoryGroup>
        <VictoryGroup color="#FFC000">
          <VictoryArea data={area2Data} labelComponent={<MyTooltip />} />
        </VictoryGroup>

        <VictoryGroup offset={0}>
          <VictoryStack colorScale={["#437eb4", "#5B9BD5", "#9cc9f3"]} >
            {datas.map((d, i) => <VictoryBar barWidth={20} key={i} data={d} labelComponent={<MyTooltip />}/>)}
          </VictoryStack>
        </VictoryGroup>


        <VictoryAxis />
        <VictoryAxis dependentAxis label={store.t("workload_Y_label")} axisLabelComponent={<VictoryLabel dy={-12} />} />


      </VictoryChart>
    </div>
  );
};

export default WorkloadChart;
